<template>
  <div>
    <Head title="Barazimet me shitës"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/financat/barazimet-me-shites">Barazimet me
        shitës
      </Link>
      <span class="text-indigo-400 font-medium">/ </span>
      <Link class="text-indigo-400 font-medium" :href="`/admin/financat/barazimet-me-shites/ne-pritje`">Në pritje</Link>
      <span class="text-indigo-400 font-medium">/ </span>
      {{periodicityType}}
    </h1>

    <info-flash-message class="w-full lg:w-1/2" :message="`Në këtë faqe shfaqen barazimet që janë skeduluar të ekzekutohen ${periodicityType}.
    Kujdes, këto barazime nuk janë të skeduluara për sot. Kthehu prapa për t'i parë barazimet e skeduluara për sot.`"></info-flash-message>


<!--    <div v-if="currentSelections != null && currentSelections.length !== 0" class="flex flex-wrap lg:flex-nowrap mb-6 lg:mb-3 items-center">-->
<!--      <button class="btn-indigo mr-3" type="button" @click="registerMultipleBarazims">Regjistro</button>-->
<!--    </div>-->

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
<!--          <th class="pb-4 pt-6 px-2">-->
<!--            <input :checked="allSelected" @click="selectAll" class="flex items-center  px-2 py-4" type="checkbox">-->
<!--          </th>-->
          <th class="pb-4 pt-6 px-2"></th>
          <th @click="sort('business_name')" class="pb-4 pt-6 px-2 cursor-pointer">Biznesi shitës</th>
          <th @click="sort('periodicity_type')" class="pb-4 pt-6 px-2 cursor-pointer">Perioda</th>
          <th  class="pb-4 pt-6 px-2">Ditët e javës</th>
          <th @click="sort('last_barazim_created_at')" class="pb-4 pt-6 px-2 cursor-pointer">Barazimi i fundit</th>
          <th @click="sort('total_sales')" class="pb-4 pt-6 px-2 cursor-pointer">Total shitje</th>
          <th @click="sort('total_shipping_cost')" class="pb-4 pt-6 px-2 cursor-pointer">Total posta</th>
          <th @click="sort('total_neto_amount')" class="pb-4 pt-6 px-2 cursor-pointer">Totali për dorëzim</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="barazim in sortedBarazims" :key="barazim.business_id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
        >

<!--          <td class="border-t px-2">-->
<!--            <input v-model="barazim.selected" :value="barazim.business_id" class="flex items-center  px-2 py-4" type="checkbox">-->
<!--          </td>-->

          <td class="w-px border-t px-2">
            <Link :href="`/admin/financat/barazimet-me-shites/regjistro?business_id=${barazim.business_id}`"
                  class="flex items-center  px-2 py-4" tabindex="-1"
            >
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </Link>
          </td>

          <td class="border-t px-2">
            {{ barazim.business_name }}
          </td>
          <td class="border-t px-2">
            {{getHRPeriodicity(barazim.barazim_periodicity_type)}}
          </td>
          <td class="border-t px-2">
            {{ getHRWeekDays(barazim.barazim_periodicity_week_days ) }}
          </td>
          <td class="border-t px-2">
            {{ barazim.barazim_created_at }}
          </td>
          <td class="border-t px-2">
            {{ barazim.total_sales }}
          </td>
          <td class="border-t px-2">
            {{ barazim.total_shipping_cost }}
          </td>

          <td class="border-t px-2">
            {{ barazim.total_neto_amount }}
          </td>
        </tr>
        <tr v-if="pendingBarazims.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje barazim.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'
import Dropdown from '@/Shared/Dropdown'
import {computed} from 'vue'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import Multiselect from '@vueform/multiselect'
import InfoFlashMessage from '@/Shared/InfoFlashMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    DangerFlashMessage,
    SearchInput,
    SearchFilter,
    Dropdown,
    FileInput,
    Modal,
    LoadingButton,
    SelectInput,
    Multiselect,
    InfoFlashMessage
  },
  layout: Layout,
  props: {
    pendingBarazims: Object,
    periodicityType: String
  },
  data(){
    return{
      currentSort: null,
      currentSortDir: 'asc'
    }
  },
  // mounted() {
  //   this.pendingBarazims.forEach((barazim) => barazim['selected'] = false);
  // },
  computed: {
    // allSelected(){
    //   return this.pendingBarazims.every(barazim => barazim.selected)
    // },
    sortedBarazims(){
      return this.pendingBarazims.sort((a,b) => {
        if(this.currentSort == null) return 0;
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;

        if(!isNaN(a[this.currentSort])){
          if( parseFloat(a[this.currentSort]) < parseFloat(b[this.currentSort])) return -1 * modifier;
          if(parseFloat(a[this.currentSort]) > parseFloat(b[this.currentSort])) return modifier;
          return 0;
        }

        if((a[this.currentSort] != null ? a[this.currentSort].toLowerCase(): '') < (b[this.currentSort] != null ? b[this.currentSort].toLowerCase() : '')) return -1 * modifier;
        if((a[this.currentSort] != null ? a[this.currentSort].toLowerCase() : '') > (b[this.currentSort] != null ? b[this.currentSort].toLowerCase() : '')) return modifier;
        return 0;
      });
    }
  },
  // data(){
  //   return {
  //     currentSelections: null,
  //   }
  // },
  // watch: {
  //   pendingBarazims: {
  //     handler() {
  //
  //       this.currentSelections = this.pendingBarazims
  //         .filter( barazim => barazim.selected )
  //         .map( barazim => barazim.business_id )
  //         .toString();
  //     },
  //     deep: true
  //   },
  // },
  methods: {
    // registerMultipleBarazims(){
    //   this.$inertia.post('/admin/financat/barazimet-me-shites/multiple',{business_ids: this.currentSelections})
    // },
    // selectAll(){
    //   let allS = this.allSelected;
    //   this.pendingBarazims.forEach(barazim => barazim.selected = !allS)
    // },
    sort(sortBy) {
      if(sortBy === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = sortBy;
    },
    getHRWeekDays(weekDays){
      let hrWeekDays = '';

      let arr = JSON.parse(weekDays);

      if(arr){
        arr.forEach(function(weekDay, index){
          if(weekDay == 0)
            hrWeekDays += 'E diele ';

          if(weekDay == 1)
            hrWeekDays += 'E hënë ';

          if(weekDay == 2)
            hrWeekDays += 'E martë ';

          if(weekDay == 3)
            hrWeekDays += 'E mërkurë ';

          if(weekDay == 4)
            hrWeekDays += 'E enjte ';

          if(weekDay == 5)
            hrWeekDays += 'E premte ';

          if(weekDay == 6)
            hrWeekDays += 'E shtunë ';
        });
      }


      return hrWeekDays;

    },
    getHRPeriodicity(periodicityType){

      let hrPeriodicity = 'Sipas dëshirës';

      if(periodicityType === 'daily'){
        hrPeriodicity = 'Çdo 24 orë';
      }

      if(periodicityType === 'weekly'){
        hrPeriodicity = 'Një herë në javë';
      }

      if(periodicityType === 'twice-weekly'){
        hrPeriodicity = 'Dy herë në javë';
      }

      if(periodicityType === 'twice-monthly'){
        hrPeriodicity = 'Çdo dy javë';
      }

      if(periodicityType === 'monthly'){
        hrPeriodicity = 'Një herë në muaj';
      }

      return hrPeriodicity;
    }
  }
}
</script>

<style scoped>

</style>
